export default {
    examinationOfThreeChromosomes : 'Examination Of Three Chromosomes',
    checkAllChromosomes: 'Check All Chromosomes',
    pGSType: 'PGS Type',
    description: 'Description',

}